"use strict";
exports.__esModule = true;
exports.joinProperties = void 0;
exports.joinProperties = function () {
    var parts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parts[_i] = arguments[_i];
    }
    return parts.filter(Boolean).join('.');
};
//# sourceMappingURL=joinProperties.js.map